import axios from "../../../config/axiosConfig";

// Registro guiado por el catálogo (radio | modem | chip | bateria | varios): crea el equipo y su historial "Registro".
export const getCatalogoRegistro = (tipo) => axios.get(`/api/registro-equipos/catalogo/${tipo}`);
export const registrarEquipo = (tipo, data) => axios.post(`/api/registro-equipos/${tipo}`, data);
export const buscarClientes = (buscar) => axios.get("/api/clientes", { params: { buscar, pageSize: 15 } });

export const crearModem = (data) => axios.post("/api/equipos-modem", data);
export const crearRadio = (data) => axios.post("/api/equipos-radio", data);
export const crearVarios = (data) => axios.post("/api/equipos-varios", data);
export const crearChip = (data) => axios.post("/api/equipos-chip", data);
export const crearBateria = (data) => axios.post("/api/equipos-bateria", data);
export const registrarAccesorio = (data) => axios.post("/api/equipos-accesorio", data);

export const getTiposAccesorioCatalogo = () => axios.get("/api/equipos-accesorio/catalogo/tipos");
export const getModelosPorTipoCatalogo = (idServicioDetalle) =>
  axios.get(`/api/equipos-accesorio/catalogo/modelos/${encodeURIComponent(idServicioDetalle)}`);
export const resolverAccesorioCatalogo = (params) => axios.get("/api/equipos-accesorio/catalogo/resolver", { params });
export const pasarAccesorioALaboratorio = (id, data) => axios.post(`/api/equipos-accesorio/${id}/pasar-laboratorio`, data);

export const getInventarioAccesorios = (ciudad) => axios.get("/api/equipos-accesorio/inventario", { params: { ciudad } });
export const moverAccesorioStock = (id, data) => axios.post(`/api/equipos-accesorio/${id}/mover`, data);

export const getHistorialAccesorio = (id) => axios.get(`/api/historial-accesorio/accesorio/${id}`);
